module.exports = __webpack_public_path__ + "img/usdc.939964c3.png";